import { ViperSelect } from "@/components";
import {
  useGetAllNotificationGroupsQuery,
  useSaveNotificationGroupMutation,
  useSuggestActiveDirectoryQuery,
} from "@/services";
import { Form, Modal } from "antd";
import { bool, func, object } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

const EditNotificationGroupModal = ({
  open,
  setOpen,
  selectedNotificationGroup,
}) => {
  const intl = useIntl();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [hasChange, setHasChange] = useState(false);
  const [notificationGroup, setNotificationGroup] = useState({});
  const [query, setQuery] = useState(null);

  const [saveNotificationGroup, { isLoading }] =
    useSaveNotificationGroupMutation();

  const { refetch: refetchNotificationGroups } =
    useGetAllNotificationGroupsQuery();

  const { data: adGroupSuggestions, isLoading: adGroupsLoading } =
    useSuggestActiveDirectoryQuery(
      { query },
      {
        skip: !query,
      }
    );

  useEffect(() => {
    setNotificationGroup(selectedNotificationGroup);

    if (!selectedNotificationGroup) return;

    const { id, name, email, activeDirectoryGroupId } =
      selectedNotificationGroup;

    if (!id || !name) return;

    searchAdGroups(name);
    setSelectedGroup({
      displayName: name,
      mail: email,
      id: activeDirectoryGroupId,
    });
    setQuery(name);
  }, [notificationGroup, selectedNotificationGroup]);

  const handleOk = () => {
    const transformedData = {
      ...notificationGroup,
      name: selectedGroup.displayName,
      email: selectedGroup.mail,
      activeDirectoryGroupId: selectedGroup.id,
    };

    saveNotificationGroup(transformedData)
      .unwrap()
      .then(() => {
        toast.success(intl.formatMessage({ id: "general.toastChangesSaved" }));
        refetchNotificationGroups();
        handleClose();
      });
  };

  const handleClose = () => {
    setNotificationGroup({});
    setHasChange(false);
    setOpen(false);
  };

  const handleADGroupSelected = (selectedGroupId) => {
    setHasChange(true);
    setSelectedGroup(
      adGroupSuggestions?.find(({ document: { id } }) => id === selectedGroupId)
        ?.document
    );
  };

  const searchAdGroups = (query) => {
    setQuery(query);
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: `notificationGroups.${
          notificationGroup?.id ? "editModalTitle" : "addModalTitle"
        }`,
      })}
      open={open}
      onOk={handleOk}
      onCancel={handleClose}
      okButtonProps={{
        loading: isLoading,
        disabled: !hasChange,
      }}
    >
      <Form>
        <Form.Item
          label={intl.formatMessage({
            id: "notificationGroups.selectGroupLabel",
          })}
        >
          <ViperSelect
            data-test-id="notification-group-search-select"
            showSearch={true}
            onFetchSuggestions={searchAdGroups}
            onChange={handleADGroupSelected}
            suggestions={adGroupSuggestions?.map(
              ({ document: { id }, suggestionText }) => ({
                value: id,
                label: suggestionText,
              })
            )}
            loading={adGroupsLoading}
            value={selectedGroup?.id}
            placeholder={intl.formatMessage({
              id: "notificationGroups.searchGroupPlaceholder",
            })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

EditNotificationGroupModal.propTypes = {
  open: bool,
  setOpen: func,
  selectedNotificationGroup: object,
};

export default EditNotificationGroupModal;
